import { Svg } from "common/assets";
import { Container, IconArrow } from "./styled";

export const UpButton = () => {
  const onUpButton = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Container onClick={onUpButton}>
        <IconArrow>
           <use href={Svg.sprite + "#icon-arrow-up"} />
        </IconArrow>
      </Container>
    </>
  );
};
